import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DeviceService} from '@app/core';
import {AdtraceService} from '@app/core/ad-trace/adtrace.service';
import {IndicatorService} from '@app/shared';
import {AppParametersService} from "@app/core/token/app-parameters.service";

@Component({
  templateUrl: './subscription-intro.component.html',
  styleUrls: ['./subscription-intro.component.scss', './../style.scss']
})

export class SubscriptionIntroComponent {


  constructor(
    public readonly appParametersService: AppParametersService,
    private readonly adtrace: AdtraceService,
    public readonly device: DeviceService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly indicator: IndicatorService,
    private readonly router: Router) {
    this.indicator.hide();
  }

  public onClick(e) {
    this.router.navigate(['buy'], {relativeTo: this.activatedRoute}).then();
  }
}
